var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "bagStep4",
      staticClass:
        "selection-summary row flex flex-col justify-center overflow w-full mt-5 mb-2",
      class: _vm.bagStep < 4 && "grayed",
    },
    [
      _vm.bagStep < 4 ? _c("div", { staticClass: "cover-up" }) : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "w-full md:mb-1 roboto md:flex justify-between" },
        [
          _c("div", { staticClass: "text-wrapper" }, [
            _c("p", { staticClass: "steps bold m-0" }, [
              _vm._v(
                "Step " +
                  _vm._s(_vm.totalSteps) +
                  " of " +
                  _vm._s(_vm.totalSteps)
              ),
            ]),
            _vm._v(" "),
            _c("h1", { staticClass: "text-center" }, [
              _vm._v(_vm._s(_vm.webstoreContent.addToBag)),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "mb-2 dark-blue-text" }, [
              _vm._v(_vm._s(_vm.webstoreContent.cartPage.summary_description)),
            ]),
            _vm._v(" "),
            _vm.activeProductInfo.productAlert
              ? _c("div", { staticClass: "product-alert" }, [
                  _vm._v(_vm._s(_vm.activeProductInfo.productAlert)),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "selection-wrapper max-w-[530px] p-2",
              class: _vm.messageWrapperClass,
            },
            [
              _c("h1", { staticClass: "m-0" }, [_vm._v("Review Items")]),
              _vm._v(" "),
              _c("hr", { staticStyle: { "margin-bottom": "30px" } }),
              _vm._v(" "),
              _c("div", { staticClass: "product-summary" }, [
                _c("p", { staticClass: "quantity" }, [
                  _vm._v("Qty: " + _vm._s(_vm.currentQuantity)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "product-info" }, [
                  _c(
                    "p",
                    {
                      staticClass: "text-lg font-medium",
                      staticStyle: { "line-height": "140%" },
                    },
                    [_vm._v(_vm._s(_vm.activeProductInfo.name))]
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticClass: "subtext font-normal",
                      staticStyle: { "line-height": "140%" },
                    },
                    [_vm._v(_vm._s(_vm.activeOffer.offerName))]
                  ),
                ]),
                _vm._v(" "),
                _c("h1", { staticClass: "price m-0" }, [
                  _vm._v(
                    _vm._s(_vm.currencySymbol.toUpperCase()) +
                      _vm._s(_vm.itemTotal.toFixed(2)) +
                      " / " +
                      _vm._s(_vm.activeOffer.defaultPaymentTerm)
                  ),
                ]),
              ]),
              _vm._v(" "),
              _vm.isSafetyEventReviewActive
                ? _c("div", { staticClass: "product-summary" }, [
                    _c("p", { staticClass: "quantity" }, [
                      _vm._v("Qty: " + _vm._s(_vm.currentQuantity)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "product-info" }, [
                      _c(
                        "p",
                        {
                          staticClass: "text-lg font-medium",
                          staticStyle: { "line-height": "140%" },
                        },
                        [_vm._v(_vm._s(_vm.webstoreContent.cartPage.ser_title))]
                      ),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          staticClass: "subtext font-normal",
                          staticStyle: { "line-height": "140%" },
                        },
                        [_vm._v(_vm._s(_vm.webstoreContent.cartPage.ser_sku))]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("h1", { staticClass: "price m-0" }, [
                      _vm._v(
                        _vm._s(_vm.currencySymbol.toUpperCase()) +
                          _vm._s(
                            (
                              _vm.safetyEventReviewPrice * _vm.currentQuantity
                            ).toFixed(2)
                          ) +
                          " / month"
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.totalCablesSubmittedCount === _vm.cablesNeededCount
                ? _c(
                    "div",
                    _vm._l(_vm.totalCompiledData, function (info, name) {
                      return _c(
                        "div",
                        { key: name, staticClass: "product-summary" },
                        [
                          _c("p", { staticClass: "quantity" }, [
                            _vm._v("Qty: " + _vm._s(info.qty)),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "product-info" }, [
                            _c(
                              "p",
                              {
                                staticClass: "text-lg font-medium",
                                staticStyle: { "line-height": "140%" },
                              },
                              [_vm._v(_vm._s(name))]
                            ),
                            _vm._v(" "),
                            info && info.list && info.list.length > 0
                              ? _c(
                                  "p",
                                  {
                                    staticClass: "subtext font-normal -mt-0.5",
                                  },
                                  [
                                    _vm._v(
                                      "for \n                            "
                                    ),
                                    _vm._l(info.list, function (value, index) {
                                      return _c("span", { key: value }, [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(value) +
                                            _vm._s(
                                              index !== info.list.length - 1
                                                ? ","
                                                : ""
                                            ) +
                                            "\n                            "
                                        ),
                                      ])
                                    }),
                                  ],
                                  2
                                )
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c("h1", { staticClass: "price m-0 font-bold" }, [
                            _vm._v("Included"),
                          ]),
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("div", { staticClass: "w-full flex justify-between" }, [
                _c("h1", { staticClass: "m-0" }, [_vm._v("Subtotal")]),
                _vm._v(" "),
                _c("h1", { staticClass: "price m-0 final-price" }, [
                  _vm._v(
                    _vm._s(_vm.currencySymbol.toUpperCase()) +
                      _vm._s(_vm.cartTotal) +
                      " / " +
                      _vm._s(_vm.activeOffer.defaultPaymentTerm)
                  ),
                ]),
              ]),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }